namespace Cfnc {
    "use strict";

    export interface ICommonConfig {
        controllerActivateSuccessEvent?: string;
        spinnerToggleEvent?: string;
        debug: boolean;
        login?: string;
        logout?: string;
        register?: string;
        reloadUser?: string;
        apiHost?: string;
        xapHost?: string;
        homeUrl?: string;
    }

    export interface ICommonProvider extends ng.IServiceProvider {
        config: ICommonConfig;
    }

    export class CommonProvider implements ICommonProvider {
        config: ICommonConfig;

        constructor(private authenticationProvider: Security.AuthenticationProvider) {
            this.config = {
                debug: false
            };
        }

        $get(): any {
            this.authenticationProvider.useFullRefreshForLoginUrl = true;
            this.authenticationProvider.useFullRefreshForRedirect = false;
            this.authenticationProvider.registerThenLogin = true;
            this.authenticationProvider.events.login = this.config.login;
            this.authenticationProvider.events.logout = this.config.logout;
            this.authenticationProvider.events.register = this.config.register;
            this.authenticationProvider.events.reloadUser = this.config.reloadUser;

            this.authenticationProvider.apiUrls.host = this.config.apiHost;
            this.authenticationProvider.apiUrls.xapHost = this.config.xapHost;
            this.authenticationProvider.providerUrls.home = this.config.homeUrl;
            return {
                config: this.config
            };
        }
    }
}